import { createContext, useContext } from 'react';

export type PathwayCompletedState = {
  showCompletedState?: boolean;
  s12nId?: string;
  userId?: string;
};

const PathwayCompletedStateContext = createContext<PathwayCompletedState>({
  showCompletedState: undefined,
  s12nId: undefined,
  userId: undefined,
});

/**
 * @description hook to see if a user has completed a pathway
 */
export const usePathwayCompletedStateContext = () => useContext(PathwayCompletedStateContext);

export const usePathwayCompletedState = () => {
  const context = useContext(PathwayCompletedStateContext);

  return context;
};

export default PathwayCompletedStateContext;
